module.exports = __webpack_public_path__ + "static/media/LiveCasinoMobileTop.6252968a.png";